import React, { useState } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';

import { functions } from '../firebase';

const verifyPublicPagePassword = functions.httpsCallable('verifyPublicPagePassword');

const errorMessages = {
  'resource-exhausted': '試行回数が上限に達しました。しばらく時間をおいてからお試しください。',
  'permission-denied': 'パスワードが正しくありません。',
  'not-found': '共有URLが無効か、有効期限が切れています。',
};

export default function PublicPagePasswordForm ({ publicKey, onVerified }) {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrorMessage(null);
    try {
      const { data: { accessToken } } = await verifyPublicPagePassword({ publicKey, password, });
      onVerified(accessToken);
    } catch(e) {
      console.error(e);
      setErrorMessage(errorMessages[e.code?.replace(/^functions\//, '')] || 'エラーが発生しました。');
    }
    setIsSubmitting(false);
  };

  return (
    <div className="d-flex justify-content-center mt-5">
      <Form className="card p-4" style={{ minWidth: 320 }} onSubmit={onSubmit}>
        <div className="mb-3 text-muted">
          このページはパスワードで保護されています。
        </div>
        <FormGroup>
          <Label>パスワード</Label>
          <Input
            type="password"
            autoFocus
            value={password}
            onChange={_ => setPassword(_.target.value)}
          />
        </FormGroup>
        {errorMessage && <div className="text-danger small mb-3">{errorMessage}</div>}
        <Button color="primary" type="submit" disabled={password.length === 0 || isSubmitting}>
          {isSubmitting ? '確認中...' : '閲覧する'}
        </Button>
      </Form>
    </div>
  );
};
